import { Navigate, useLocation } from "react-router-dom";

// Вкладка «Зоны» слита с главной; старые ссылки /stations ведут на хаб,
// сохраняя query-параметры (номер телефона).
export default function StationsRedirect() {
  const loc = useLocation();
  return <Navigate to={`/hub${loc.search}`} replace />;
}
